module.exports = __webpack_public_path__ + "static/media/slider4.730d3dcc.jpg";